import axios from "axios";

const requestAllCode = () => {
  return axios.get(`${process.env.VUE_APP_APIURL}/api/admin/code/code-AllList`);
};

export { requestAllCode };
